const dbRequest           = require('../../../../../js-network/db-request')
const multitable          = require('../../../../../components/multitable/multitable')
const snack               = require ('../../../../../components/snack/snack')
const snackCustomerCredit = require('./customercredit-snack')
const textfieldHandler    = require ('../../../../../components/textfield/textfield-handler')
const autocomplete        = require ('../../../../../components/textfield/autocomplete')

export function getAllInvoiceCredited(detail, htmlFc) {  //console.log('updateCsutomerField -> ', htmlFc)

  let input_customer = htmlFc.fullcontHTML.querySelector("#customercredit_form_customer_id");
  let input_selected = input_customer.getAttribute("selected");


  if (JSON.parse(input_selected).length > 0) {

    load(detail, JSON.parse(input_selected)[0], htmlFc)

  }
}

const load = (detail, value, htmlFc) => {


  return loadDB(detail, value)
    .then((result) => {



      //the entity was deleted
      if (result.multiTables[0] == "") {
        snackCustomerCredit.start({ act: 'show', id: 'noCreditedInvoice', });
        multitable.start({ act: 'clean', entityMT: htmlFc.entityMT })
        return
      }/**/

      if (result.multiTables[1] == "") {
        snackCustomerCredit.start({ act: 'show', id: 'noInvoicePending', });
        multitable.start({ act: 'clean', entityMT: htmlFc.entityMT })
        return
      }/**/

      // console.log(JSON.parse(result.multiTables[0]));
      // return;

      multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: JSON.parse(result.multiTables[0]) })
      multitable.start({ act: 'loadResultToForm', entityMT: htmlFc.entityMT, resultMT: JSON.parse(result.multiTables[1]) })

      multitable.start({ act: 'generator_insert', entityMT: htmlFc.entityMT })


    }).catch((error) => {

      throw error;
      //console.log('Error Getting Invoice', error)

    })
}/**/

async function loadDB(detail, value) {


  detail.inf = { customer_id: value }



  ///yeison/php/settings.php
  //const result = await dbRequest.start(detail, 'php/settings.php' ) //do the insert
  const result = await dbRequest.start(detail, 'server/php/sql/getAllInvoiceCredited.php') //do the insert

  if (result.status != "ok") { throw (result) }

  return result
}

//validar antes de proceder a guardar o actualizar
export function validated(detail, htmlFc) {

  let customer          = htmlFc.fullcontHTML.querySelector("#customercredit_form_customer_id");
  let customer_selected = customer.getAttribute("selected");
  //verificar si se selecciono un cliente
  if (JSON.parse(customer_selected).length == 0) {
    textfieldHandler.error(customer);
    snack.start({ act: 'show', id: 'inputErrors'});
    return false;
  }else{
    textfieldHandler.errorClean(customer);
  }


  let InputsError = [];
  let InputsErrorForCheck = [];
  let allInputsEmpty = true;
  // buscar las lineas del mt  Credited Invoices
  let linesCreditedSale     = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_credited_sale .line");
  for (let index = 0; index < linesCreditedSale.length; index++) {
    let line = linesCreditedSale[index];
    let inputAddCreditedAmount = line.querySelector('.add_credited_amount input');
    let inputUsedCredit = line.querySelector('.used_credit input');
    let UsedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                          parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
    
    if (inputAddCreditedAmount.checked) {
      if (UsedCredit == 0) {
        //guardar en el arreglo los input used credit que tenga el valor 0 y que el input del tipo checkbox de la misma linea este marcado
        InputsError.push(inputUsedCredit);
      }else{
        //significa que hay lineas llenas y marcadas
        allInputsEmpty = false;
        if(!verifyValueCredited(inputUsedCredit,htmlFc)){
          return false;
        }
      }
    }else{
      if (UsedCredit > 0) {
        //guardar en el arreglo los input used credit que tenga el valor  diferente a 0 
        //y que el input del tipo checkbox de la misma linea no este marcado
        InputsErrorForCheck.push(inputUsedCredit);
      }
    }

  }

  //validar que por lo menos se tenga un campo correctamente lleno en el mt Credited Invoices
  if (allInputsEmpty) {
    let linesEmpty  = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_credited_sale .line .used_credit");
    linesEmpty.forEach(textfield => {
      textfieldHandler.error(textfield);
    });
    snackCustomerCredit.start({ act: 'show', id: 'fillAtLeastOneField'});
    return false;
  }

  allInputsEmpty = true;
  // buscar las lineas del mt Unpaid Invoices
  let linesPaidSale  = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_paid_sale .line");
  for (let index = 0; index < linesPaidSale.length; index++) {
    let line = linesPaidSale[index];
    let inputAddAmount  = line.querySelector('.add_amount input');
    let inputSentAmount = line.querySelector('.sent_amount input');
    let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                          parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);
    
    if (inputAddAmount.checked) {
      if (SentAmount == 0) {
        //guardar en el arreglo los input used credit que tenga el valor 0 y que el input del tipo checkbox de la misma linea este check
        InputsError.push(inputSentAmount);
      }else{
        //significa que hay lineas llenas y marcadas
        allInputsEmpty = false;
        if (!verifyValueSent(inputSentAmount, htmlFc)) {
          return false;
        } 
      }
    }else{
      if (SentAmount > 0) {
        //guardar en el arreglo los input used credit que tenga el valor  diferente a 0 
        //y que el input del tipo checkbox de la misma linea no este marcado
        InputsErrorForCheck.push(inputSentAmount);
      }
    }


  }

  //validar que por lo menos se tenga un campo correctamente lleno en el mt Unpaid Invoices
  if (allInputsEmpty) {
    let linesEmpty  = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_paid_sale .line .sent_amount");
    linesEmpty.forEach(textfield => {
      textfieldHandler.error(textfield);
    });
    snackCustomerCredit.start({ act: 'show', id: 'fillAtLeastOneField'});
    return false;
  }

  

  if (InputsError.length > 0) {
    snackCustomerCredit.start({ act: 'show', id: 'fillLineChecked'});
    InputsError.forEach(input => {
      textfieldHandler.error(input.closest(".textfield"));
    });
    return false;
  }

  if (InputsErrorForCheck.length > 0) {
    snackCustomerCredit.start({ act: 'show', id: 'fillLineChecked'});
    InputsErrorForCheck.forEach(input => {
      textfieldHandler.error(input.closest(".textfield"));
    });
    return false;

  }

  if (getTotalCreditedToUse(htmlFc) > getTotalSentAmount(htmlFc)) {
    
    for (let index = 0; index < linesCreditedSale.length; index++) {
      let line = linesCreditedSale[index];
      let inputAddCreditedAmount = line.querySelector('.add_credited_amount input');

      if (inputAddCreditedAmount.checked) {
        let textfieldUsedCredit = line.querySelector('.used_credit');
        textfieldHandler.error(textfieldUsedCredit);
      }
    }

    snackCustomerCredit.start({ act: 'show', id: 'greaterAmount'});
    return false;
  }


  //remover las lineas que no se van a guardar
  linesCreditedSale.forEach(function (line) {
    let inputUsedCredit = line.querySelector('.used_credit input');
    let UsedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                          parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
    
    if (UsedCredit == 0) {
      line.remove();
    }
  });

  //remover las lineas que no se van a guardar
  linesPaidSale.forEach(function (line) {
    let inputSentAmount = line.querySelector('.sent_amount input');
    let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                          parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);
    
    if (SentAmount == 0) {
      line.remove();
    }
  });

  return true;
}

export function keyValueCredited(detail, htmlFc) {
  verifyValueCredited(detail.ev.target, htmlFc);
}


//validar el valor digitado en las facturas con credito
function verifyValueCredited(input, htmlFc) {
  let inputUsedCredit      =  input;
  let UsedCredit           = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                              parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);

  if (UsedCredit != 0) {
    let inputAvailableCredit = inputUsedCredit.closest('.line').querySelector('.available_credit input');
    let availableCredit      = (inputAvailableCredit.value   == "" || parseFloat(inputAvailableCredit.value)   == NaN || 
                                parseFloat(inputAvailableCredit.value)   == 0) ? 0 : parseFloat(inputAvailableCredit.value);

    if (UsedCredit > availableCredit) {
      snackCustomerCredit.start({ act: 'show', id: 'greaterUsedCredit'});
      textfieldHandler.error(inputUsedCredit.closest(".textfield"));
      return false;
    } else {
      textfieldHandler.errorClean(inputUsedCredit.closest(".textfield"));
    }
  }

  calculateAmount(htmlFc);

  //si llega hasta aqui es que todo esta bien con el valor usado en los credito
  // entonces se va a proceder a validar los creditos digitados vs lo que se va a pagar en la factura
  return  VerifyTotalSentAmount(htmlFc);;

}

export function addAmountCredited(detail, htmlFc) {

  let inputAdd        =  detail.ev.target;
  let inputUsedCredit = inputAdd.closest('.line').querySelector('.used_credit input');
  //quitar error de input por si lo tiene
  textfieldHandler.errorClean(inputUsedCredit.closest(".textfield"));


  if (inputAdd.checked) {
    let inputCreditAvailable = inputAdd.closest('.line').querySelector('.available_credit input');
    let creditAvailable      = (inputCreditAvailable.value   == "" || parseFloat(inputCreditAvailable.value)   == NaN || 
                               parseFloat(inputCreditAvailable.value)   == 0) ? 0 : parseFloat(inputCreditAvailable.value);
    let UsedCredit           = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                               parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);

    if (UsedCredit < 1) {
      inputUsedCredit.value = parseFloat(inputCreditAvailable.value);
    }else{
      if (UsedCredit > creditAvailable ) {
        snackCustomerCredit.start({ act: 'show', id: 'greaterUsedCredit'});
        textfieldHandler.error(inputUsedCredit.closest(".textfield"));
        return;
      }
    }
  } else {
    inputUsedCredit.value = 0;
  }




  calculateAmount(htmlFc);
  VerifyTotalSentAmount(htmlFc);


}

function calculateAmount(htmlFc) {
  
  let inputAmount = htmlFc.fullcontHTML.querySelector("#customercredit_form_amount input");
  inputAmount.value = getTotalCreditedToUse(htmlFc);

}

//busca el total del credited to use del mt Credited Invoices
function getTotalCreditedToUse(htmlFc) {
    // Inicializar el total
    let totalCreditToUse = 0;
    // Obtener todas las filas
    const lines = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_credited_sale .line");
  
    lines.forEach((line) => {
      let inputAdd = line.querySelector(".add_credited_amount input");
  
      if (inputAdd.checked) {
        let inputUsedCredit = line.querySelector(".used_credit input");
        let usedCredit      = (inputUsedCredit.value   == "" || parseFloat(inputUsedCredit.value)   == NaN || 
                              parseFloat(inputUsedCredit.value)   == 0) ? 0 : parseFloat(inputUsedCredit.value);
  
        totalCreditToUse += usedCredit;
      }
  
  
    });

    return totalCreditToUse;
  
}

//busca el total del Paying Amount del mt Unpaid Invoices
function getTotalSentAmount(htmlFc) {
  // Inicializar el total
  let totalSentAmount = 0;

  // Obtener todas las filas
  const lines = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_paid_sale .line");

  lines.forEach((line) => {
    let inputAdd = line.querySelector(".add_amount input");

    if (inputAdd.checked) {
      let inputSentAmount = line.querySelector(".sent_amount input");
      let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                            parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);

      totalSentAmount += SentAmount;
    }


  });

  return totalSentAmount;

}


export function addAmount(detail, htmlFc) {

  let inputAdd        = detail.ev.target;
  let inputSentAmount = inputAdd.closest('.line').querySelector('.sent_amount input');
  //quitar error de input por si lo tiene 
  textfieldHandler.errorClean(inputSentAmount.closest(".textfield"));

  if (inputAdd.checked) {
    let SentAmount = (inputSentAmount.value == "" || parseFloat(inputSentAmount.value) == NaN ||
                     parseFloat(inputSentAmount.value) == 0) ? 0 : parseFloat(inputSentAmount.value);

    if (SentAmount == 0) {
      let totalCreditToUse = getTotalCreditedToUse(htmlFc);
      let totalSentAmount  = getTotalSentAmount(htmlFc);

      if (totalCreditToUse > 0) {
        let inputDueAmount   = inputAdd.closest('.line').querySelector('.due_amount input');
        let dueAmount        = (inputDueAmount.value == "" || parseFloat(inputDueAmount.value) == NaN ||
                               parseFloat(inputDueAmount.value) == 0) ? 0 : parseFloat(inputDueAmount.value);

        //credito sin usar para colocar a la factura a pagar
        let creditAvailable = totalCreditToUse - totalSentAmount;
        if (creditAvailable > 0 ) {
          //si la cantidad que se debe es menor al credito a usar, se coloca la cantidad que se debe completa
          // de lo contrario se coloca el total de credito sin usar
          inputSentAmount.value = dueAmount < creditAvailable ? dueAmount : creditAvailable;
        }else{
          inputSentAmount.value = 0;
        }
      }

    }else{
      VerifyTotalSentAmount(htmlFc);
    }

  } else {
    inputSentAmount.value = 0;
  }

}

// verificar que el monto total a pagar de las facturas no sea mayor al credito a pagar
function VerifyTotalSentAmount(htmlFc) {
  let totalCreditToUse  = getTotalCreditedToUse(htmlFc);
  let totalSentAmount   = getTotalSentAmount(htmlFc);
  const inputSentAmount = htmlFc.fullcontHTML.querySelectorAll("#customercredit_form_customer_credit_vs_paid_sale .sent_amount");

  if (totalSentAmount > totalCreditToUse) {
    inputSentAmount.forEach(input => {
      textfieldHandler.error(input);
    });
    snackCustomerCredit.start({ act: 'show', id: 'insufficientCredit'});
    return false;
  }else{
    inputSentAmount.forEach(input => {
      textfieldHandler.errorClean(input);
    });
  }

  return true; 

}

export function keyValueSent(detail, htmlFc) {
  verifyValueSent(detail.ev.target, htmlFc);
}

//verificar que el monto a pagar de la factura no sea mayor a lo que se debe de la factura
export function verifyValueSent(input, htmlFc) {
  let inputSentAmount =  input;
  let SentAmount      = (inputSentAmount.value   == "" || parseFloat(inputSentAmount.value)   == NaN || 
                              parseFloat(inputSentAmount.value)   == 0) ? 0 : parseFloat(inputSentAmount.value);

  if (SentAmount != 0) {
    let inputDueAmount  = inputSentAmount.closest('.line').querySelector('.due_amount input');
    let dueAmount       = (inputDueAmount.value   == "" || parseFloat(inputDueAmount.value)   == NaN || 
                          parseFloat(inputDueAmount.value)   == 0) ? 0 : parseFloat(inputDueAmount.value);

    if (SentAmount > dueAmount) {
      snackCustomerCredit.start({ act: 'show', id: 'greaterSentAmount'});
      textfieldHandler.error(inputSentAmount.closest(".textfield"));
      return false;
    } else {
      textfieldHandler.errorClean(inputSentAmount.closest(".textfield"));
    }
  }

  //si llega hasta aqui es que todo esta bien con el valor usado en el pago de la factura
  // entonces se va a proceder a validar el total de lo pagado por la factura vs los creditos disponibles
  return VerifyTotalSentAmount(htmlFc);

}





// export function verifyCheckBox(htmlFc){

//   // console.log('htmlFc.entityMT[0].data:', htmlFc.entityMT[0].data);
//   setTimeout(()=>{
//         if (htmlFc.entityMT[0].data.length > 0) {
//               let firstDataItem = htmlFc.entityMT[0].data;
//               firstDataItem.forEach((a)=>{

//                     console.log('sent_amount:', a.sent_amount);
//                     console.log('total_amount:', a.po_total_amount);

//                     if (parseFloat(a.sent_amount) == parseFloat(a.po_total_amount)) {
//                           let mt = htmlFc.fullcontHTML.querySelector('#customercredit_form_payment_vs_sale')
//                           setTimeout(()=>{
//                                 let checkbox = mt.querySelectorAll('#add_amount')
//                                 checkbox.forEach((check)=>{
//                                       check.querySelector('.elem').checked = true
//                                       check.classList.add('textfield-disabled')

//                                 })
//                                 // console.log(checkbox.querySelector('.elem'))
//                           },100)
//                           console.log('valores iguales')
//                     }
//               })
//         } else {
//               console.log('El array data está vacío.');
//         }
//   },500)
// }



// export function otherFieldCredit(detail, htmlFc) {

//   setTimeout(() => {
//     let chipCont_label = detail.ev.target.closest('.textfield').querySelector('.chip-cont label');
//     //console.log('@@@@@@@@@@@', chipCont_label)
//     let line = detail.ev.target.closest('.line');
//     let sale = line.querySelector('.saleId');
//     let saleOtherField = get_otherField(sale);  
//  console.log("$$$$$$$$$$$$$$$$$",saleOtherField);
//     //line.querySelector('.textfield-autocomplete  .otherField').value =  "";
//     line.querySelector('.amount input').value = saleOtherField.credit - saleOtherField.spent_credit;
//     line.querySelector('.amount input').focus();
//   }, 100);

// }


// export function get_otherField(ac_line) {


//   try {

//     let rawFields = ac_line.querySelector(".otherField");

//     if (rawFields == null) {
//       throw "Null";
//     }

//     return JSON.parse(rawFields.getAttribute('otherField'));

//   } catch (error) {
//     console.error("Error parsing JSON:", error);
//   }
// }